/* custom-cl-reveal.js — shared IO reveal-once (REBUILD-SPEC M4; the sanctioned IO use).
   Elements with [data-cl-reveal] get .is-revealed when they enter the viewport, once.
   Stagger via data-cl-reveal="N" (ms delay). Reduced-motion → reveal immediately. */
(function () {
  if (window.__clRevealBound) return;
  window.__clRevealBound = true;

  function revealAll() {
    document.querySelectorAll('[data-cl-reveal]').forEach(function (el) { el.classList.add('is-revealed'); });
  }

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', revealAll);
    else revealAll();
    return;
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var delay = parseInt(el.getAttribute('data-cl-reveal'), 10) || 0;
      setTimeout(function () { el.classList.add('is-revealed'); }, delay);
      io.unobserve(el);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.1 });

  function bind() {
    document.querySelectorAll('[data-cl-reveal]').forEach(function (el) { io.observe(el); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind);
  else bind();
})();
